var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85169 9.45692L1.89147 17.8421C1.83264 17.9017 1.76223 17.9463 1.68539 17.9726C1.60856 17.999 1.52724 18.0064 1.44738 17.9944C1.36912 18.0048 1.28972 17.9965 1.21473 17.9702C1.13974 17.9439 1.07099 17.9002 1.01329 17.8421L0.148437 16.9271C0.00410972 16.9271 0.00410972 16.7748 0.00410972 16.6225C-0.00555619 16.5395 0.00241805 16.4552 0.0274266 16.376C0.0524351 16.2969 0.0938201 16.2249 0.148437 16.1656L6.95515 9L0.148437 1.98793C0.0936617 1.92849 0.0521837 1.85632 0.0271702 1.77692C0.0021567 1.69753 -0.00573087 1.61301 0.00410972 1.52981C-0.00555619 1.44681 0.00241805 1.36252 0.0274266 1.28335C0.0524351 1.20418 0.0938201 1.1322 0.148437 1.0729L1.01773 0.157861C1.07493 0.100476 1.14294 0.0571491 1.21711 0.0308578C1.29128 0.00456649 1.36984 -0.00406547 1.44738 0.00555522C1.52724 -0.00642721 1.60856 0.00103094 1.68539 0.0273837C1.76223 0.0537365 1.83264 0.0983168 1.89147 0.157861L9.85169 8.54308C9.90631 8.60239 9.94769 8.67436 9.9727 8.75354C9.99771 8.83271 10.0057 8.917 9.99602 9C10.0057 9.083 9.99771 9.16729 9.9727 9.24646C9.94769 9.32563 9.90631 9.39761 9.85169 9.45692Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleArrow);
export default __webpack_public_path__ + "static/media/toggle-arrow.4d84bdaeb0fe01fb5f51ac56764e8689.svg";
export { ForwardRef as ReactComponent };